import { UserEffects } from './toast.effects';
import { CityesEffects } from './city.effects';
import { ClientsEffects } from './users.effects';
import { FilialEffects } from './filial.effects';

export const effects: any[] = [
  CityesEffects,
  UserEffects,
  ClientsEffects,
  FilialEffects,
];

export * from './toast.effects';
export * from './city.effects';
export * from './users.effects';
export * from './filial.effects';
